function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.795 8.111h-7.59l.595 9.333h6.4l.595-9.333zm-7.59-1.555c-.895 0-1.605.753-1.553 1.646l.595 9.334C7.296 18.358 7.977 19 8.8 19h6.4c.824 0 1.504-.642 1.553-1.464l.595-9.334a1.556 1.556 0 0 0-1.553-1.646h-7.59z",
  fill: "#97A2C8"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19 8.111H5V6.79c0-.129.104-.233.233-.233h13.534c.128 0 .233.104.233.233V8.11z",
  fill: "#97A2C8"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.311 5c.258 0 .467.209.467.467v1.4a.467.467 0 0 1-.467.466h-.622a.467.467 0 0 1-.467-.466v-1.4c0-.258.21-.467.467-.467h.622z",
  fill: "#97A2C8"
});

const SvgTrash = props => React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none"
}, props), _ref, _ref2, _ref3);

export default SvgTrash;